import type { Column } from "@tanstack/react-table";
import SwapVerticalIcon from "@mui/icons-material/SwapVert";

import { cn } from "~/lib/utils";
import { Button } from "../ui/button";

interface DataTableColumnHeaderProps<TData, TValue>
  extends React.HTMLAttributes<HTMLDivElement> {
  column: Column<TData, TValue>;
  title: string;
}

export function DataTableColumnHeader<TData, TValue>({
  column,
  title,
  className,
}: DataTableColumnHeaderProps<TData, TValue>) {
  if (!column.getCanSort()) {
    return <div className={cn("w-full justify-start flex px-4 py-2", className)}>{title}</div>;
  }

  return (
    <Button
      className={cn("w-full justify-start", className)}
      variant="ghost"
      onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
    >
      {title}
      <SwapVerticalIcon className="ml-2 h-4 w-4" />
    </Button>
  );
}
